<h2>{{ (tripType === 'Start' ? 'duty start' : 'duty end') | i18next: { format: 'capitalize' } }}</h2>
<div class="vspace-32px"></div>

<form
	[formGroup]="form"
	*ngIf="form"
	class="container"
>
	<div class="left-column">
		<!-- column 1  -->
		<div class="form-group">
			<!-- Inspection Types  -->
			<div class="label">{{ "select inspection types" | i18next: { format: "capitalize" } }}</div>
			<div class="vspace-16px"></div>

			<app-missing-input [show]="!hasSelectedInspectionTypes && isLeftActive">
				<app-multi-select-chips
					[placeholder]="'add inspection type' | i18next: { format: 'capitalize' }"
					[disabled]="numberOfSelectedInspectionTypes === 5"
					[options]="inspectionTypes"
					(added)="inspectionTypeAdded($event)"
					(removed)="inspectionTypeRemoved($event)"
				></app-multi-select-chips>
			</app-missing-input>
			<div
				class="max-5-inspection-types"
				*ngIf="numberOfSelectedInspectionTypes === 5"
			>
				{{ "maximum of 5 inspection types allowed" | i18next }}
			</div>

			<div class="vspace-32px"></div>

			<!-- start condition  -->
			<div class="label">{{ "inspection is expected when selected event occurs" | i18next }}:</div>
			<div class="vspace-16px"></div>

			<app-missing-input [show]="!hasStartCondition && isLeftActive">
				<div class="start-condition want-error-border">
					<!-- power  -->
					<label>
						<input
							type="radio"
							formControlName="startCondition"
							[value]="'power'"
							(change)="onRadioBtnChange(radioButtonValues.POWER)"
						/>
						{{ powerLabel[semantics] }}
					</label>

					<ng-container *ngIf="wantMovementOption">
						<div class="vspace-8px"></div>
						<!-- moves -->
						<label>
							<input
								type="radio"
								formControlName="startCondition"
								[value]="'after_distance'"
								(change)="onRadioBtnChange(radioButtonValues.MOVES)"
							/>
							{{ "vehicle moves 10 miles radius" | i18next: { format: "capitalize" } }}
						</label>
					</ng-container>
					<!-- select zones -->
					<div class="vspace-8px"></div>

					<label class="hspace-16px">
						<input
							id="zone-radio-btn"
							type="radio"
							formControlName="startCondition"
							[value]="'selected-zone'"
							(change)="onRadioBtnChange(radioButtonValues.ZONE)"
						/>
						{{ whenZoneLabel[semantics] }}
					</label>
					<div class="vspace-8px"></div>
				</div>
			</app-missing-input>

			<app-missing-input [show]="!disableZoneDropdown && !hasZonesSelected">
				<div class="zones">
					<!-- zones "dropdown" (just a btn with a down arrow for simplicity since it opens to a modal) -->
					<button
						type="button"
						class="zone-selector border want-error-border"
						(click)="openCategoryZoneDialog()"
						[disabled]="disableZoneDropdown"
					>
						<div>
							<p>{{ zonesSelectionLabel }}</p>
							<mat-icon>keyboard_arrow_down</mat-icon>
						</div>
					</button>
				</div>
			</app-missing-input>

			<!-- expire minutes -->
			<div class="expire-minutes">
				{{ "inspection is expected" | i18next }}
				<select
					formControlName="expireMinutes"
					class="timezone want-error-border"
					[attr.aria-label]="'expiration minutes' | i18next: { format: 'capitalize' }"
				>
					<option
						*ngFor="let minuteOption of minuteOptions"
						[value]="minuteOption.value"
					>
						{{ minuteOption.label }}
					</option>
				</select>
				{{ (tripType === 'Start' ? 'inspection is expected before the event' : 'inspection is expected after the event') | i18next }}
			</div>
			<div class="vspace-32px"></div>

			<!-- frequency  -->
			<div class="label">{{ "how often inspection is expected for the selected event" | i18next }}:</div>
			<div class="vspace-8px"></div>

			<app-missing-input [show]="false">
				<div class="form-group">
					<div class="frequency want-error-border">
						<label>
							<input
								type="radio"
								formControlName="frequency"
								[value]="TripFrequency.trip"
								checked="true"
							/>
							{{ "every time the event occurs" | i18next: { format: "capitalize" } }}
						</label>
						<div class="vspace-8px"></div>
						<label>
							<input
								type="radio"
								formControlName="frequency"
								[value]="TripFrequency.workPeriod"
							/>
							{{ "once per work period" | i18next: { format: "capitalize" } }}
						</label>
						<div class="vspace-8px"></div>
						<label>
							<input
								type="radio"
								formControlName="frequency"
								[value]="TripFrequency.tripWithinWorkperiod"
								checked="false"
							/>
							{{ "every time the event occurs within the work period" | i18next: { format: "capitalize" } }}
						</label>
					</div>
				</div>
			</app-missing-input>
		</div>
	</div>
	<div
		class="right-column"
		*ngIf="isWorkPeriodFrequency"
	>
		<!-- Column 2 -->
		<div class="label">{{ "define work period when inspection is expected" | i18next }}</div>
		<div class="vspace-8px"></div>

		<!-- time zone  -->
		<app-missing-input
			[show]="form.get('timeZone')?.invalid && isRightActive"
			*ngIf="workPeriods.length > 0"
		>
			<select
				formControlName="timeZone"
				class="timezone want-error-border"
				[attr.aria-label]="'timezone' | i18next: { format: 'capitalize' }"
			>
				<option value="">{{ "timezone" | i18next: { format: "capitalize" } }}</option>
				<option
					*ngFor="let tz of timeZones"
					[value]="tz.value"
				>
					{{ tz.label }}
				</option>
			</select>
		</app-missing-input>
		<!-- work periods  -->
		<div class="form-group">
			<ng-container formArrayName="workPeriods">
				<div
					*ngFor="let period of workPeriods.controls; let i = index"
					[formGroupName]="i"
					class="work-period"
				>
          <button
						*ngIf="workPeriods.controls.length > 1"
						class="remove-btn"
						(click)="removeWorkPeriod(i)"
            [attr.aria-label]="'remove work period' | i18next: { format: 'capitalize' }"
            type="button"
					>
            <mat-icon class="icon-close" aria-hidden="true">close</mat-icon>
            </button>
					<label>
						<input
							#allWeekCheckbox
							type="checkbox"
							formControlName="allWeek"
							(change)="onAllWeek($event, i)"
						/>
						{{ "all week" | i18next: { format: "capitalize" } }}
					</label>

					<div class="days-time-range">
						<!-- select days  -->
						<app-missing-input [show]="!hasAnyDaySelected(i) && isRightActive">
							<div class="days-range want-error-border">
								<div
									class="days"
									[formGroupName]="'days'"
								>
									<label
										*ngFor="let day of weekdays; let d = index"
										class="day-label"
										tabindex="0"
										role="checkbox"
										[attr.aria-checked]="period.get('days')?.get(dayFormKeys[d])?.value"
										(keydown.space)="$event.preventDefault(); toggleDayCheckbox(i, d)"
										(keydown.enter)="toggleDayCheckbox(i, d)"
									>
										<input
											type="checkbox"
											[formControlName]="dayFormKeys[d]"
											class="hidden"
											aria-hidden="true"
										/>
										<div
											class="day"
											[ngClass]="{ selected: period.get('days')?.get(dayFormKeys[d])?.value }"
										>
											{{ day }}
											<mat-icon
												class="check-icon"
												*ngIf="period.get('days')?.get(dayFormKeys[d])?.value"
												aria-hidden="true"
											>
												check
											</mat-icon>
										</div>
									</label>
								</div>
							</div>
						</app-missing-input>

						<!-- select time  range -->
						<div class="time-range">
							<app-missing-input [show]="isStartTimeMissing(i) && isRightActive">
								<div class="want-error-border time">
									<app-time-picker
										[label]="'start' | i18next: { format: 'capitalize' }"
										[value]="period.get('start')?.value"
										(timeChange)="updateStartTime($event, i)"
									></app-time-picker>
								</div>
							</app-missing-input>

							<div class="hspace-16px"></div>
							<app-missing-input [show]="isEndTimeMissing(i) && isRightActive">
								<div class="want-error-border time">
									<app-time-picker
										[label]="'end' | i18next: { format: 'capitalize' }"
										[resetTimeWhenMeridiemChanges]="true"
										[value]="period.get('end')?.value"
										[showNotifier]="isNotifierShowed(i)"
										[disabled]="isStartTimeMissing(i)"
										(timeChange)="updateEndTime($event, i)"
									></app-time-picker>
								</div>
							</app-missing-input>
						</div>
					</div>
				</div>
			</ng-container>

			<div class="vspace-16px"></div>

			<app-circle-button
				*ngIf="workPeriods.controls.length < 3"
				(clicked)="addWorkPeriod()"
				[diameterPx]="30"
				[label]="addLabel"
			>
				+
			</app-circle-button>
		</div>
	</div>
</form>
